import React, { Component } from 'react'
import S from 'shorti'
import { Link } from 'react-router'
import { Button, Modal, Alert } from 'react-bootstrap'
import controller from '../../controller'
import config from '../../../config/public'
import _ from 'lodash'
import './checkout.scss'
import './domains.scss'
import Card from 'react-credit-card'
class Domains extends Component {
  constructor() {
    super()
    this.state = {
      data: {}
    }
  }
  componentDidMount() {
    const data = this.state.data
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    controller.getCustomer({ access_token }, (err, res) => {
      data.payments = res.data
      this.setState({
        data
      })
      // Test for update card
      if (this.props.location && this.props.location.query.show_card_form && !data.show_checkout_modal && !data.show_card_form && data.payments) {
        data.show_card_form = true
        data.show_checkout_modal = true
        data.submit_disabled = true
        this.setState({
          data
        })
      }
    })
  }
  handleSubmit(e) {
    e.preventDefault()
    controller.getDomainSuggestions(this, this.refs.domain.value)
  }
  handleDomainClick(suggestion, is_selected) {
    const data = this.state.data
    if (data.selected_domains && data.selected_domains.length && !is_selected)
      return
    if (!data.selected_domains)
      data.selected_domains = []
    if (!_.find(data.selected_domains, { domain: suggestion.domain }))
      data.selected_domains.push(suggestion)
    else
      data.selected_domains = _.filter(data.selected_domains, suggestion_filter => suggestion_filter.domain !== suggestion.domain)
    this.setState({
      data
    })
  }
  flipCard(side) {
    let item
    if (side === 1)
      item = 'name'
    else
      item = 'cvc'
    const data = this.state.data
    data.focused = item
    this.setState({
      data
    })
  }
  checkForValid() {
    setTimeout(() => {
      const data = this.state.data
      if (data.number && data.first_name && data.last_name && data.expiry && data.cvc)
        delete data.submit_disabled
      else
        data.submit_disabled = true
      this.setState({
        data
      })
    }, 100)
  }
  handleTextChange(key, e) {
    this.checkForValid()
    const data = this.state.data
    data[key] = e.target.value
    this.setState({
      data
    })
  }
  purchaseDomains() {
    const data = this.state.data
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    const domain = data.selected_domains[0].domain
    const agreement = data.agreement
    const params = {
      stripe: data.stripe.id,
      domain: domain,
      agreement: {
        keys: [agreement.agreementKey],
        ip: '127.0.0.1',
        at: '111111'
      },
      access_token
    }
    controller.purchaseDomain(params, (err, res) => {
      delete data.submitting
      delete data.submit_disabled
      delete data.show_payment_fail
      if (res && res.code === 'OK') {
        // data.show_payment_success = true
        window.location.href = `/${window.location.search}&message=payment-success`
      }
      else
        data.show_payment_fail = true
      this.setState({
        data
      })
    })
  }
  formHasErrors() {
    const data = this.state.data
    // Find errors
    if (data.submit_disabled) {
      data.errors = []
      if (!data.number)
        data.errors.push('number')
      if (!data.first_name)
        data.errors.push('first_name')
      if (!data.last_name)
        data.errors.push('last_name')
      if (!data.expiry)
        data.errors.push('expiry')
      if (!data.cvc)
        data.errors.push('cvc')
      this.setState({
        data
      })
      return true
    }
    return false
  }
  handlePaymentSubmitClick() {
    const data = this.state.data
    data.submitting = true
    delete data.errors
    if (this.formHasErrors())
      return
    this.setState({
      data
    })
    // Update
    if (data.payments && data.show_card_form) {
      this.updateCurrentCard()
      return
    }
    // New card / Existing card purchase
    if (!data.payments || !data.payments.length)
      this.submitNewCardPayment()
    else
      this.submitCurrentCardPayment()
  }
  handleEditCardClick() {
    const data = this.state.data
    delete data.errors
    if (this.formHasErrors())
      return
    data.submitting = true
    this.setState({
      data
    })
    this.updateCurrentCard()
  }
  updateCurrentCard() {
    const data = this.state.data
    data.stripe = _.last(data.payments)
    this.setState({
      data
    })
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    const params = {
      id: data.stripe.id,
      access_token
    }
    controller.deleteCustomer(params, (err, res) => {
      this.submitNewCardPayment()
    })
  }
  submitNewCardPayment() {
    const data = this.state.data
    if (!data.expiry) {
      data.show_payment_fail = true
      delete data.submitting
      delete data.submit_disabled
      this.setState({
        data
      })
      return
    }
    window.Stripe.setPublishableKey(config.stripe_pk)
    window.Stripe.card.createToken({
      name: `${data.first_name} ${data.last_name}`,
      number: data.number,
      cvc: data.cvc,
      exp_month: data.expiry.substring(0, 2),
      exp_year: '20' + data.expiry.slice(-2)
    }, (status, response) => {
      if (status === 200) {
        let access_token
        if (this.props.location)
          access_token = this.props.location.query.access_token
        const params = {
          token: response.id,
          access_token
        }
        controller.submitPayment(params, (err, res) => {
          data.stripe = res.data
          this.setState({
            data
          })
          if (data.selected_domains)
            this.purchaseDomains()
          else {
            delete data.submitting
            delete data.submit_disabled
            data.show_card_updated_success = true
            this.setState({
              data
            })
          }

        })
      } else {
        data.show_payment_fail = true
        delete data.submitting
        delete data.submit_disabled
        this.setState({
          data
        })
        return
      }
    })
  }
  submitCurrentCardPayment() {
    const data = this.state.data
    data.stripe = _.last(data.payments)
    this.setState({
      data
    })
    this.purchaseDomains()
  }
  getDomainAgreement() {
    const data = this.state.data
    data.getting_agreement = true
    this.setState({
      data
    })
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    const params = {
      domain: data.selected_domains[0],
      access_token
    }
    controller.getDomainAgreement(params, (err, res) => {
      delete data.getting_agreement
      data.agreement = res.data[0]
      this.setState({
        data
      })
    })
  }
  handleViewAgreementClick() {
    const data = this.state.data
    data.show_agreement_modal = true
    this.setState({
      data
    })
  }
  handleCheckoutClick() {
    this.getDomainAgreement()
    const data = this.state.data
    data.show_checkout_modal = true
    this.setState({
      data
    })
  }
  getCart() {
    const data = this.state.data
    let cart
    if (data.selected_domains) {
      let total = 0
      cart = (
        <div style={ S('fixed b-40 r-40 w-400') }>
          { data.selected_domains &&
            data.selected_domains.map((suggestion, i) => {
              total = suggestion.price + total
              return (
                <div style={ S('mb-20 bg-fff br-3 p-15') } key={'key-' + i}>
                  <div style={ S('pull-left mr-10 pointer') } onClick={ this.handleDomainClick.bind(this, suggestion) }>&times;</div>
                  <div style={ S('pull-left') }>{ suggestion.domain }&nbsp;&nbsp;</div>
                  <div style={ S('pull-right') }>${ suggestion.price / 1000000 }</div>
                  <div className="clearfix"></div>
                </div>
              )
            })
          }
          <Button bsStyle="primary" style={ S('bg-f67608 p-15 color-fff br-3 border-none w-100p') } onClick={ this.handleCheckoutClick.bind(this) }>
            { data.selected_domains.length } Domain{ data.selected_domains.length !== 1 ? 's' : ''} - ${ total / 1000000 }&nbsp;&nbsp;&nbsp;&nbsp;|
            &nbsp;&nbsp;&nbsp;&nbsp;Continue to Checkout
          </Button>
        </div>
      )
    }
    return cart
  }
  getSummary() {
    const data = this.state.data
    let cart
    if (data.selected_domains) {
      let total = 0
      cart = (
        <div style={ S('w-100p') }>
          { data.selected_domains &&
            data.selected_domains.map((suggestion, i) => {
              total = suggestion.price + total
              return (
                <div style={ S('mb-20 bg-fff br-3 p-15') } key={'key-' + i}>
                  <div style={ S('pull-left mr-10 pointer') } onClick={ this.handleDomainClick.bind(this, suggestion) }>&times;</div>
                  <div style={ S('pull-left') }>{ suggestion.domain }&nbsp;&nbsp;</div>
                  <div style={ S('pull-right') }>${ suggestion.price / 1000000 }</div>
                  <div className="clearfix"></div>
                </div>
              )
            })
          }
          <div>
            <div style={ S('pull-left color-fff') }>Order Total</div>
            <div style={ S('pull-right color-fff') }>${ total / 1000000 }</div>
          </div>
          <div className="clearfix"></div>
        </div>
      )
    }
    return cart
  }
  showCardForm() {
    const data = this.state.data
    data.show_card_form = true
    delete data.show_card_updated_success
    delete data.show_payment_success
    data.submit_disabled = true
    this.setState({
      data
    })
  }
  hideCardForm() {
    const data = this.state.data
    delete data.show_card_form
    delete data.submit_disabled
    this.setState({
      data
    })
  }
  getCardArea() {
    const data = this.state.data
    const payments = data.payments
    let full_name = ''
    if (data.first_name)
      full_name = data.first_name + ' ' + (data.last_name ? data.last_name : '')
    let number
    let first_name
    let last_name
    let expiry
    let cvc
    if (data.number)
      number = data.number
    if (data.first_name)
      first_name = data.first_name
    if (data.last_name)
      last_name = data.last_name
    if (data.expiry)
      expiry = data.expiry
    if (data.cvc)
      cvc = data.cvc
    const last_payment = _.last(payments)
    let cancel_button
    if (payments && last_payment) {
      cancel_button = (
        <div style={ S('color-2196f3 pointer') } onClick={ this.hideCardForm.bind(this) }>Cancel</div>
      )
    }
    const error_message = (
      <div style={ S('mt-20') } className="text-danger">All fields are required</div>
    )
    let card_area = (
      <div style={ S('pull-left p-40') }>
        <div style={ S('mb-20') }>
          <Card
            number={number}
            form='form'
            name={full_name}
            expiry={expiry}
            cvc={cvc}
            focused={data.focused}/>
        </div>
        <div style={ S('w-370') }>
          <form>
            <div className={`form-group${data.errors && data.errors.indexOf('number') !== -1 ? ' has-error' : ''}`}>
              <label>Card Number</label>
              <input type="text" className="form-control" name="number" onChange={ this.handleTextChange.bind(this, 'number') } value={ number }/>
            </div>
            <div className="form-group">
              <div className={`form-group${data.errors && data.errors.indexOf('first_name') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-45p pull-left mr-5p') }>
                  <label>First name</label>
                  <input type="text" className="form-control" name="first_name" onChange={ this.handleTextChange.bind(this, 'first_name') } value={ first_name }/>
                </div>
              </div>
              <div className={`form-group${data.errors && data.errors.indexOf('last_name') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-50p pull-left') }>
                  <label>Last name</label>
                  <input type="text" className="form-control" name="last_name" onChange={ this.handleTextChange.bind(this, 'last_name') } value={ last_name }/>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="form-group">
              <div className={`form-group${data.errors && data.errors.indexOf('expiry') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-50p pull-left') }>
                  <label>Expiry</label>
                  <input placeholder="DD/YY" style={ S('w-100') } maxLength="4" type="text" className="form-control" name="expiry" onChange={ this.handleTextChange.bind(this, 'expiry') } value={ expiry }/>
                </div>
              </div>
              <div className={`form-group${data.errors && data.errors.indexOf('cvc') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-50p pull-left') }>
                  <label>CVC</label>
                  <input style={ S('w-100') } maxLength="4" type="text" className="form-control" name="cvc" onBlur={ this.flipCard.bind(this, 1) } onFocus={ this.flipCard.bind(this, 2) } onChange={ this.handleTextChange.bind(this, 'cvc') } value={ cvc }/>
                </div>
              </div>
              <div className="clearfix"></div>
              { data.errors ? error_message : ''}
            </div>
          </form>
        </div>
        { cancel_button }
      </div>
    )
    if (payments && last_payment && !data.show_card_form) {
      const bg = {
        backgroundColor: 'rgba(32, 150, 243, 0.05)'
      }
      card_area = (
        <div style={ S('pull-left m-10 h-370 w-440 br-3') }>
          <div style={ S('mb-20') }>
            <div style={ S('pull-left mr-20 font-17') }>
              Your credit and debit cards
            </div>
            <div className="clearfix"></div>
          </div>
          <div style={ S('mb-20 h-1 bg-ddd') }/>
          <div style={ {...S('border-1-solid-2096F3 p-15 font-14 pull-left w-100p'), ...bg } }>
            <div style={ S('pull-left font-14 mr-20') }>
              Ending in {last_payment.source.last4} 
            </div>
            <div style={ S('pull-left font-14 mr-20') }>
              {last_payment.source.name}
            </div>
            <div style={ S('pull-left font-14 mr-20') }>
              {last_payment.source.exp_month}/{last_payment.source.exp_year}
            </div>
            <div style={ S('pull-right font-14 pointer color-2196f3') } onClick={ this.showCardForm.bind(this) }>
              Update Card
            </div>
          </div>
        </div>
      )
    }
    return card_area
  }
  render() {
    const data = this.state.data
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    const bg_gradient = 'linear-gradient(to bottom, rgba(38, 51, 69, 0.9), #18222e)'
    let fail_message_area
    if (data.show_payment_fail) {
      fail_message_area = (
        <div style={ S('mt-10') }>
          <Alert bsStyle="danger">
            Payment Failed.  Please try again.
          </Alert>
        </div>
      )
    }
    let button_area = (
      <Button bsSize="large" style={ S('w-100p') } bsStyle="primary" onClick={ this.handlePaymentSubmitClick.bind(this) } className={ data.submit_disabled || data.submitting ? 'disabled' : '' }>
        { data.submitting ? 'Submitting...' : 'Submit'}
      </Button>
    )
    if (data.show_card_form) {
      button_area = (
        <Button bsSize="large" style={ S('w-100p') } bsStyle="primary" onClick={ this.handleEditCardClick.bind(this) } className={ data.submit_disabled || data.submitting ? 'disabled' : '' }>
          { data.submitting ? 'Submitting...' : 'Edit Card'}
        </Button>
      )
    }
    let domain_agreement_area
    if (!data.show_card_form) {
      domain_agreement_area = (
        <div style={ S('text-center color-fff mt-10') }>
          By clicking submit payment you agree to the&nbsp;
          <span style={ S('w-100p pointer color-f67608') } onClick={ this.handleViewAgreementClick.bind(this) }>
            { data.getting_agreement ? 'Getting agreement...' : 'View Domain Name Registration Agreement' }
          </span>
        </div>
      )
    }
    let actions_area = (
      <div>
        { button_area }
        { fail_message_area }
        { domain_agreement_area }
      </div>
    )
    if (data.show_payment_success) {
      actions_area = (
        <div style={ S('text-center') }>
          <div style={ S('mb-20') }>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          </div>
          <div style={ S('font-22 color-fff') }>
            Payment Successful!
          </div>
        </div>
      )
    }
    if (data.show_card_updated_success) {
      actions_area = (
        <div style={ S('text-center') }>
          <div style={ S('mb-20') }>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          </div>
          <div style={ S('font-22 color-fff') }>
            Payment Option Edited!
          </div>
        </div>
      )
    }
    return (
      <div className="futura" style={ { ...S('absolute w-100p h-100p'), backgroundImage: bg_gradient } }>
        <div style={ { ...S('absolute w-100p h-100p'), overflow: 'scroll' } }>
          <Link style={ S('absolute t-20 l-20 color-f67608 pointer') } to={`/store?access_token=${access_token}`}>Back</Link>
          <Link to={`/store?access_token=${access_token}`} style={ S('absolute t-20 r-20 color-f67608 pointer') }>Choose My Domain Later</Link>
          <div style={ S('ml-130 relative t-30p') }>
            <div>
              <div style={ S('font-36 color-fff text-left t-20p mb-30') }>SEARCH FOR A DOMAIN NAME</div>
              <div style={ S('color-fff') }>Your default domain is: { this.props.location ? this.props.location.query.domain : '' }</div>
              <div style={ S('color-fff') }>Search for a custom domain below:</div>
            </div>
            <div style={ S('pr-40 w-500') }>
              <form onSubmit={this.handleSubmit.bind(this)}>
                <div style={ S('mb-20') }>
                  <input ref="domain" type="text" style={ { ...S('border-none font-100 color-fff'), background: 'transparent', outline: 'none' } } autoFocus/>
                  <div style={ S('w-900 bg-fff h-1 op-.1 mb-20') }/>
                  <Button className={ data.is_getting_domains ? 'disabled' : '' } bsSize="large" bsStyle="primary" type="submit">{ data.is_getting_domains ? 'Searching...' : 'Search' }</Button>
                </div>
                <div style={ S('color-fff') }>
                  { data.domain_suggestions &&
                    data.domain_suggestions.map((suggestion, i) => {
                      let is_selected
                      if(data.selected_domains && _.find(data.selected_domains, { domain: suggestion.domain }))
                        is_selected = true
                      return (
                        <div style={ S('mb-20') } key={'key-' + i}>
                          <div style={ S('pull-left') }>{ suggestion.domain }</div>
                          <div style={ S('pull-right') }>
                            ${ suggestion.price / 1000000 }&nbsp;&nbsp;
                            <Button className={ data.selected_domains && data.selected_domains.length && !is_selected ? 'disabled' : '' } bsStyle={ is_selected ? 'danger' : 'primary' } onClick={ this.handleDomainClick.bind(this, suggestion, is_selected) }>
                              { is_selected ? 'Remove x' : 'Select' }
                            </Button>
                          </div>
                          <div className="clearfix"></div>
                        </div>
                      )
                    })
                  }
                </div>
              </form>
            </div>
            { this.getCart() }
          </div>
        </div>
        <Modal className="futura" show={data.show_checkout_modal} onHide={controller.closeModal.bind(this)} bsSize="large">
          <div style={ S('color-fff absolute r-20 t-10 z-1 pointer font-18') } onClick={controller.closeModal.bind(this)}>&times;</div>
          <Modal.Body>
            { this.getCardArea() }
            <div style={ S('pull-left bg-141b25 absolute w-400 minh-100p r-0 t-0 p-50 pt-10asdf') }>
              <h2 style={ S('color-fff') }>{ data.show_card_form ? 'Edit Payment Option' : 'Order Summary' }</h2>
              <div style={ S('mb-20') }>
                { !data.show_card_form ? this.getSummary() : '' }
              </div>
              { actions_area }
            </div>
            <div className="clearfix"></div>
          </Modal.Body>
        </Modal>
        <Modal className="futura modal--not-centered" show={data.show_agreement_modal} onHide={controller.closeAgreementModal.bind(this)} bsSize="large">
          <div style={ S('color-fff absolute r-20 t-10 z-1 pointer font-18') } onClick={controller.closeAgreementModal.bind(this)}>&times;</div>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{ __html: data.agreement ? data.agreement.content : '' }} />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default Domains


// WEBPACK FOOTER //
// ./src/components/Domains/index.js